import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Slot from './Slot';
function Content(props, ref) {
  return React.createElement(Slot, _extends({
    element: "section",
    slot: "content",
    ref: ref
  }, props));
}
var EzContent = forwardRef(Content);
EzContent.displayName = 'EzContent';
export default EzContent;